import {
  UtcDate,
} from '@/helpers/date';

export default {
  computesRequired: true,
  params: ['itemType'],
  validate (value, { itemType }) {
    const message = `The ${itemType} date must not be in the future.`;

    const dateOfIncidentUtc = new UtcDate(value);
    const todayUtc = new UtcDate();

    if (dateOfIncidentUtc.isAfter(todayUtc)) return message;

    return true;
  },
};
